var items = document.querySelectorAll(".multicolumn-list--hover .multicolumn-list__item");
items.forEach(function(item) {
  item.addEventListener(
    "mouseover",
    (event) => {
      items.forEach(function(item) {
        item.classList.add('is-small');
      });
      item.classList.add('is-active');
    },
    false,
  );

  item.addEventListener(
    "mouseout",
    (event) => {
      items.forEach(function(item) {
        item.classList.remove('is-small');
      });
      item.classList.remove('is-active');
    },
    false,
  );
});